import { Injectable } from '@angular/core';



declare let gtag:Function;
export class GoogleAnalyticsService {

 

  constructor() { 

  }

  dataLayer: any

   

  public eventEmitter( 
    pageName: string
     )
      { 
         gtag(
          
          {'event':'v_form','form':
              this.GetFormInfo(pageName)
                  
                  }
         )
          
      
    }
 mobileOrLaptopdevice(){
 
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){

    
   return 'Mobile'
  }else{
   return 'Web'
  }

 }

  GetFormInfo(pageName:string){
 const  res= { 'formType': "" ,'formId': "" ,'formStatus': "",  'stepName': "", 'stepNumber': 0 }
  switch(pageName.toLowerCase()) {
       case "contact":
      // code block
      res.formType="B2B-Rx: Form-Contact";
      res.formId="B2B-Rx_Form_Contact";
      res.formStatus="B2B-Rx: Form-Contact";
      res.stepName="Contact";
      res.stepNumber=0;
      return res;//   break;
       case "organization":
      // code block
      res.formType="B2B-Rx: Form-Organization";
      res.formId="B2B-Rx_Form_Organization";
      res.formStatus="B2B-Rx: Form-Organization";
      res.stepName="Organization";
      res.stepNumber=1;
      return res;//   break;
        case "services":
      res.formType="B2B-Rx: Form-Services";
      res.formId="B2B-Rx_Form_Services";
      res.formStatus="B2B-Rx: Form-Services";
      res.stepName="Services";
      res.stepNumber=2;
      return res;//  break;
        case"clinic-details":
     //res.formType="B2B-Rx: Form-ClinicDetails";
      res.formType="B2B-Rx: Form-ClinicDetails";
      res.formId="B2B-Rx_Form_ClinicDetails";
      res.formStatus="B2B-Rx: Form-ClinicDetails";
      res.stepName="Clinic-Details";
      res.stepNumber=3;
      return res;//   break;
        case"coverage-options":
        res.formType="B2B-Rx: Form-CoverageOptions";
      res.formId="B2B-Rx_Form_CoverageOptions";
      res.formStatus="B2B-Rx: Form-CoverageOptions";
      res.stepName="Coverage-Options";
      res.stepNumber=4;
      return res;//   break;
        case"review and submit":
        res.formType="B2B-Rx: Form-ReviewAndSubmit";
        res.formId="B2B-Rx_Form_ReviewAndSubmit";
        res.formStatus="B2B-Rx: Form-ReviewAndSubmit";
      res.stepName="Review and Submit";
      res.stepNumber=5;
      return res;//  break;
        case"thanks":
        res.formType="B2B-Rx: Form-ThankYou";
      res.formId="B2B-Rx_Form_ThankYou";
      res.formStatus="B2B-Rx: Form-ThankYou";
      res.stepName="Thank You";
      res.stepNumber=6;
      return res;// break;
    default:
      break;
      // code block
      
  }
  return res;
}
   

 
}
